<template>
    <!-- 孟郎诗词页面 -->
    <div class="lang-page">
        <!-- 集合列表 -->
        <div class="collection-list">
            <!-- 集合单个条目 -->
            <div class="collection-item" v-for="item in collections">
                <!-- 封面 -->
                <div class="cover">
                    <img :src="item.img | fullPath" alt="">
                </div>
                <!-- 集合信息 -->
                <div class="info">
                    <!-- 名称 -->
                    <div class="name" @click="$router.push('/langList/'+item.id+'/'+item.name)">{{item.name}}</div>
                    <!-- 简介 -->
                    <div class="intro" v-html="changeFormat(item.description)"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {GetLangCollections} from "@/request/lang";
    import Vue from 'vue';

    export default {
        name: "LangPage",
        created(){
            // TODO 指定导航栏类型
            this.$store.commit("nav/typeUpdate",3);
            // TODO 获取孟郎诗词集合数据
            GetLangCollections()
                .then(res => {
                    if (res.code === 200){
                        this.collections = res.data.list;
                    }
                })
        },
        data(){
            return{
                collections:[]
            }
        },
        methods:{
            changeFormat(value) {
                let toHtml = Vue.filter('toHtml');
                return toHtml(value);
            }
        }
    }
</script>

<style scoped lang="less">
    .lang-page{
        margin-top: 93px;
        .collection-list{
            width: 70%;
            margin: 25px auto;
            padding-top: 15px;
            /* 单个条目 */
            .collection-item{
                display: flex;
                justify-content: flex-start;
                padding: 25px;
                box-sizing: border-box;
                background-color: white;
                margin-bottom: 30px;
                border-radius: 15px;
                box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
                /* 封面 */
                .cover{
                    width: 150px;
                    img{
                        width: 150px;
                    }
                }
                /* 信息 */
                .info{
                    margin-left: 15px;
                    /* 名称 */
                    .name{
                        font-size: 20px;
                        font-weight: bold;
                        margin-bottom: 15px;
                        cursor: pointer;
                        user-select: none;
                    }
                    /* 简介 */
                    .intro{
                        font-size: 17px;
                        line-height: 27px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 4;
                        -webkit-box-orient: vertical;
                        letter-spacing: 1px;
                        color: #606266;
                    }
                    /* 名称被hover时 */
                    .name:hover{
                        color: #c04851;
                    }
                }
            }
        }
    }
</style>